 import React, {
	Component,
	PropTypes
} from 'react';
import moment from "moment";
import {
	Link
} from "react-router";
import {getUserId} from 'UTIL/common'
 import userService from 'SERVICES/ella/userService'
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
const userType = {
	0:"普通用户",
	1:"服务商",
	2:"管理员",
	3:"门店"
}
 import ellaService from 'SERVICES/purifier/ella/ellaService'
 import Tip from 'COMPONENT/tip'
 import {language} from 'UTIL/common'
 import BoxHeader from "CONFIG/component/boxHeader"
 import ModalDel from 'COMPONENT/ModalDel'
 import Modal from 'COMPONENT/modal'
 import {timesTampsToData} from 'CONFIG/function'
function enumFormatter(cell, row, enumObject) {
  return enumObject[row.userTypeId];
}
const returnMsg=(body)=>{
     if (body.code == 8001) {
         $("#success_msg").text(body.msg);
         $("#success_tip").removeClass("hidden");
         $("#success_tip").focus();
         setTimeout(function() {
             $("#success_tip").addClass("hidden");
         }, 3000);
     } else {
         $("#error_msg").text(body.msg);
         $("#error_tip").removeClass("hidden");
         $("#error_tip").focus();
         setTimeout(function() {
             $("#error_tip").addClass("hidden");
         }, 3000);
     }
 }
export default class UserList extends Component {
	constructor(props) {
		super(props);
		this.delList = this.delList;
		this.delClick = this.delClick;
		this.handle = this.handle.bind(this);
		this.search = this.search.bind(this);
		this.onPageChange = this.onPageChange.bind(this);
		this.state = {
			list: [],
			size: 10,
			current: 1,
			total: 0,
			delRow: {id:"",name:""},
            disableId : '',
			enableId : '',
		};
	}
	componentDidMount() {
        this.onPageChange(this.state.current,this.state.size);
	}
	
	delList(id, name) {
		var delRow = {
            id:id,
            name:name,
        };
        this.setState({
            delRow:delRow
        });
        console.log(delRow);
	};

	handle(cell, row) {
		//0 启用 1 禁用
		var div = row.state == 0?<a className="btn btn-sm btn-danger" data-target="#disable" data-toggle="modal"
										onClick={this.disableClick.bind(this,row.id,row.roleName)}>禁用</a>:
			<a className="btn btn-sm btn-dropbox" data-target="#enable" data-toggle="modal"
			   onClick={this.enableClick.bind(this,row.id,row.roleName)}>启用</a>;

			return <div>
				{div}&nbsp;&nbsp;
				<Link  to = {"/ella/user/user/userEdit/"+row.id} className="btn btn-sm btn-info">
					编辑
				</Link>&nbsp;&nbsp;
                {/*<a className="btn btn-md btn-danger" data-target="#tipModal" data-toggle="modal"*/}
                {/*onClick={this.delList.bind(this,row.id,row.roleName)}>删除</a>&nbsp;&nbsp;*/}
				<Link  to = {"/ella/user/user/userDetail/"+row.id} className="btn btn-warning btn-sm">
					详情
				</Link>
			</div>

	};
    disableClick(id){
    	this.setState({
            disableId : id,
		})
	}
    enableClick(id){
        this.setState({
            enableId : id,
        })
	}
	onPageChange(page, sizePerPage, e) {
		const json = {
			current:page,
            size:sizePerPage,
            search:$("#name").val(),
			userId:getUserId(),
		};
		const data = JSON.stringify(json);
		userService.getUserList({data}).then(body=>{
			console.log(body)
            if(body.data !=null) {
                this.setState({
                    current: body.data.current,
                    pageSize: body.data.total,
                    list: body.data.records,
                    total: body.data.total
                })
            }
		})
	}
	search() {
		this.onPageChange(this.state.current,this.state.size);
	}
    //
    // delClick(id){
    // }


    dateFormate(cell,row){
		return row.regTime == null?"":timesTampsToData(row.regTime);
    }
    disable(){
    	var id = this.state.disableId;
    	ellaService.disableUser(id).then(body=>{
            this.onPageChange(this.state.current,this.state.size);
            returnMsg(body)
		})
	}
	enable(){
    	var id = this.state.enableId;
    	ellaService.enableUser(id).then(body=>{
            this.onPageChange(this.state.current,this.state.size);
            returnMsg(body)
		})
	}
    stateHandle(cell,row){
		return row.state == 0?'启用':'禁用';
	}
	render() {
		const options = {
            noDataText:"没找到数据",
            page: this.state.current, //当前页
            sizePerPageList: [10, 15, 20],
            sizePerPager: this.state.pageSize,
            pageStartIndex: 1,
            paginationSize: 5,
            firstPage: '首页',
            lastPage: '尾页',
            onPageChange: this.onPageChange,
        }
		return (
			<div >
				<section className="content-header " >
					 <h1> 用户管理 <small>用户列表</small> </h1>
				</section>
				 <section className="content" >
					 <div className="box box-primary color-palette-box">
						 <div className="box-header with-border">
							 <i className="fa fa-list"></i>
							 <h3 className="box-title">用户列表</h3>
							 <div style={{marginRight:"10px",float:"right"}}>
								  <Link  to = "/ella/user/user/userAdd" className="btn btn-success btn-md"  >
										<i className="fa fa-plus-circle"></i> 添加
								  </Link>
							</div>
						 </div>
							<div className="box-body">
								<Tip ids=""/>
								<div className="title-box">
									<div className="clearfix">
										<div className="col-sm-3">
											<label className="col-sm-5 control-name">查询条件</label>
											<div className="col-sm-7">
												<input type="text" className="form-control" id='name'
													   placeholder='姓名、登录名、电话'/>
											</div>
										</div>
										<button type="button" className="btn btn-info" onClick={this.search.bind(this)}>{language()['query']}</button>
									</div>
								</div>
								<div >
									<BootstrapTable data = {this.state.list}  remote={true} fetchInfo={{ dataTotalSize: this.state.total }} striped hover pagination={true} options={options} ref='table' height={'auto'} >
										<TableHeaderColumn isKey dataField='id' hidden={true}> id</TableHeaderColumn>
										<TableHeaderColumn dataField='loginName' > 登录名</TableHeaderColumn>
										<TableHeaderColumn dataField='realName'> 姓名</TableHeaderColumn>
										<TableHeaderColumn  dataField='telephone' >电话</TableHeaderColumn>
										<TableHeaderColumn  dataField='regTime'  dataFormat={this.dateFormate}>组册日期</TableHeaderColumn>
										<TableHeaderColumn  dataFormat={ enumFormatter } formatExtraData={ userType }>角色</TableHeaderColumn>
										<TableHeaderColumn  dataFormat={this.stateHandle.bind(this)}  >状态</TableHeaderColumn>
										<TableHeaderColumn  dataFormat={this.handle}  columnClassName="td-mid">操作</TableHeaderColumn>
									</BootstrapTable>
								</div>
							</div>
						</div>
				</section>
				{/*<ModalDel id="tipModal" delModSure = {this.delClick.bind(this,this.state.delRow.id)}/>*/}
				<Modal modal={{"id":'enable',"title":'enable',"text":'readyEnable'}}  modalSure= {this.enable.bind(this)}/>
				<Modal modal={{"id":'disable',"title":'disable',"text":'readyDisable'}}  modalSure= {this.disable.bind(this)}/>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/ella/user/user/userList.js